"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _getCookies = _interopRequireDefault(require("../../getCookies"));

var _trackers = require("../../trackers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var InAppWebView = function InAppWebView() {
  (0, _react.useEffect)(function () {
    var cookies = (0, _getCookies["default"])();
    var inAppWebView = cookies['blocket-in-app-web-view'];

    _trackers.pulse.update({
      object: {
        custom: {
          inAppWebView: inAppWebView
        }
      }
    });

    _trackers.gtm.update({
      inAppWebView: inAppWebView
    });
  }, []);
  return null;
};

var _default = InAppWebView;
exports["default"] = _default;
//# sourceMappingURL=InAppWebView.js.map